/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateUserDto { 
    /**
     * User first name
     */
    firstName: string;
    /**
     * User last name
     */
    lastName: string;
    /**
     * User email address
     */
    email: string;
    /**
     * User password (minimum 8 characters)
     */
    password: string;
    /**
     * Gateway user role
     */
    role: CreateUserDto.RoleEnum;
}
export namespace CreateUserDto {
    export const RoleEnum = {
        Admin: 'admin',
        Operator: 'operator',
        Viewer: 'viewer'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


